import React, { Component } from 'react';

// 기타 react
import { connect } from "react-redux";
import compose from "recompose/compose";
import {
    reduxForm, 
    formValueSelector,
    getFormValues,
    getFormSubmitErrors,
    SubmissionError
} from 'redux-form';
import { FormattedMessage } from "react-intl";
import isEmpty from 'lodash-es/isEmpty';
import ReactJson from 'react-json-view';
import TagsInput from "react-tagsinput";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from "@material-ui/core/FormHelperText";

// custom
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import Button from "components/react-template/CustomButtons/Button.jsx";
import ButtonFileUploaderComponent from "components/uploader/ButtonFileUploaderComponent";
import GridContainer from "components/react-template/Grid/GridContainer.jsx";
import GridItem from "components/react-template/Grid/GridItem.jsx";
import CustomInput from "components/react-custom-template/CustomInput/CustomInput.jsx";
import CustomRadioGroup from "components/react-custom-template/CustomRadioGroup/CustomRadioGroup";
import FormField from "components/common/input/FormField";
import { FILE_UPLOAD_MAX_SIZE } from "util/constants";
import { 
    extractTagsFromFile as extractTagsFromFileAction,
    crudCreateForMultipart as crudDocumentFileCreateAction
} from "store/actions/dataActions";
import { 
    required,
    isBucketName,
    minLength3,
    trimAndLower,
    trimLeft,
    getFormInitValues
} from 'util/form';
import {
    FILE_REGISTRATION_SAVE_OPTIONS,
    DEFAULT_VALUES_FOR_FILE_REGISTRATION
} from 'util/document';


class DocumentFileRegistrationDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
          fileNames: [],
          files: [],
          tags: null,
        };
    }

    componentWillReceiveProps(nextProps) {
        if( nextProps.refreshVersion !== this.props.refreshVersion ) {
            if( this.props.anyTouched || this.props.dirty ) {
                this.props.reset();
                this.setState({
                    fileNames: [],
                    files: [],
                    tags: null
                });
                this.props.change("fileNames", []);
            }
        } else if( nextProps.tags !== this.props.tags ) {
            this.handleTags(nextProps.tags);
        }
    }

    handleSetSelectedFile = (fileNames, files) => {
        console.log("fileNames:", fileNames.split(","))
        console.log("files:", files)
        this.setState({
            fileNames: fileNames.split(","),
            files: files
        });
        this.props.change("fileNames", fileNames);

        if( files.length > 0 ) {
            let formData = new FormData();
            formData.append("file", files[0]);
            this.props.dispatchExtractTags("DOCUMENT.FILE.TAGS", formData);
        }
    };

    handleTags = (regularTags) => {
        this.setState({ tags: regularTags });
    }

    // 리렌더링이 불필요한 케이스 정의 
    shouldComponentUpdate(nextProps, nextState){
        if (
            nextProps.saveOptionValue === this.props.saveOptionValue &&
            nextProps.result === this.props.result &&
            nextProps.submitting === this.props.submitting &&
            nextProps.valid === this.props.valid &&
            nextProps.submitErrors === this.props.submitErrors &&
            this.state === nextState
        ) {
            console.log("DocumentFileRegistrationDetail >> shouldComponentUpdate : false");
            return false;
        }
        console.log("DocumentFileRegistrationDetail >> shouldComponentUpdate : true");
        return true;
    }

    // 저장버튼 클릭
    onSubmit = () => {
        console.log("onSubmit")

        const file = this.state.files[0];
        if( !file ) {
            throw new SubmissionError( {fileNames: <FormattedMessage id="common.file.empty" />} );
        }
        console.log("onSubmit OK")
        let formData = this._makeParams(file);
        this.props.dispatchCrudCreate(this.props.menu, formData);
    };

    _makeParams(file) {
        const { bucketName, save, owner } = this.props.formValues;

        let formData = new FormData();
        formData.append("file", file);
        if( save === "on" ) {
            formData.append("bucketName", bucketName);
        }
        formData.append("owner", owner);
        formData.append("tags", this.state.tags);
        return formData;
    }

    render() {
        const { fileNames, files, tags } = this.state;
        const { 
            classes, color, saveOptionValue, result, 
            submitting, valid, handleSubmit, submitErrors
        } = this.props;
        const errorMsg = submitErrors["fileNames"];

        return (
            <form autoComplete="off" onSubmit={handleSubmit(this.onSubmit)} noValidate>
                {/* 파일 */}
                <section className="formSection">
                    <div className="formSectionTitle">
                        <FormLabel classes={{ root: "row-label" }} required>
                            <FormattedMessage id="document.file.registration.file" />
                        </FormLabel>
                    </div>
                    <GridContainer>
                        <GridItem xs={12}>
                            <ButtonFileUploaderComponent
                                multiple={false}
                                maxSize={FILE_UPLOAD_MAX_SIZE}
                                //accept=".csv"
                                accept={[".docx", ".doc", ".pptx", ".ppt", ".xlsx", ".xls", ".hwp", ".pdf", ".txt",
                                        ".png", ".bmp", ".gif", ".jpg", ".jpeg"
                                ]}
                                setSelectedFile={this.handleSetSelectedFile}
                                fileNames={fileNames.join()}
                            />
                            { errorMsg && <FormHelperText className={classes.labelRootError}>
                                {errorMsg}
                            </FormHelperText> }
                        </GridItem>
                    </GridContainer>
                </section>

                {/* 파일의 태그 */}
                { tags &&
                    <section className="formSection">
                        <div className="formSectionTitle">
                            <FormLabel classes={{ root: "row-label" }}>
                                <FormattedMessage id="document.file.tags" />
                            </FormLabel>
                        </div>
                        <GridContainer>
                            <GridItem xs={12} sm={6} lg={4}>
                                <FormattedMessage id="document.file.tags.input">
                                    { placeHolder => (<TagsInput
                                            value={tags || []}
                                            onChange={this.handleTags}
                                            tagProps={{ className: "react-tagsinput-tag rose" }}
                                            inputProps={{ placeholder: placeHolder }}
                                        />
                                    )}
                                </FormattedMessage>
                            </GridItem>
                        </GridContainer>
                    </section>
                }

                {/* 파일 저장 여부 */}
                <section className="formSection">
                    <div className="formSectionTitle">
                        <FormLabel classes={{ root: "row-label" }} required>
                            <FormattedMessage id="document.file.save" />
                        </FormLabel>
                    </div>
                    <GridContainer>
                        <GridItem xs={12} sm={6} lg={4}>
                            <div className={classes.inlineChecks}>
                                <FormField
                                    name="save"
                                    component={CustomRadioGroup}
                                    color={color}
                                    selectOptions={FILE_REGISTRATION_SAVE_OPTIONS}
                                    row
                                />
                            </div>
                        </GridItem>
                    </GridContainer>
                </section>

                {/* 파일을 저장하는 경우 bucketname */}
                { saveOptionValue === FILE_REGISTRATION_SAVE_OPTIONS[0].value && 
                    <section className="formSection">
                        <div className="formSectionTitle">
                            <FormLabel classes={{ root: "row-label" }} required>
                                <FormattedMessage id="document.bucket.name" />
                            </FormLabel>
                        </div>
                        <GridContainer>
                            <GridItem xs={12} sm={6} lg={4}>
                                <FormField
                                    name="bucketName"
                                    component={CustomInput}
                                    color={color}
                                    labelId="document.bucket.name"
                                    formControlProps={{ fullWidth: true, required: true }}
                                    inputProps={{ inputProps: { maxLength: 16 } }}
                                    validate={[required, isBucketName]}
                                    normalize={trimAndLower}
                                />
                            </GridItem>
                        </GridContainer>
                    </section>
                }

                {/* 등록자 */}
                <section className="formSection">
                    <div className="formSectionTitle">
                        <FormLabel classes={{ root: "row-label" }} required>
                            <FormattedMessage id="document.owner" />
                        </FormLabel>
                    </div>
                    <GridContainer>
                        <GridItem xs={12} sm={6} lg={4}>
                            <FormField
                                name="owner"
                                component={CustomInput}
                                color={color}
                                labelId="document.owner"
                                formControlProps={{ fullWidth: true }}
                                inputProps={{ inputProps: { maxLength: 20 } }}
                                validate={[required, minLength3]}
                                normalize={trimLeft}
                            />
                        </GridItem>
                    </GridContainer>
                </section>
                <GridContainer 
                    justify={"center"}
                    alignItems={"center"}>
                    <GridItem>
                        <Button
                            color={color}
                            onClick={this.onSubmit}
                            disabled={submitting || files.length === 0 || !valid}
                        >
                            <FormattedMessage id="document.file.add" />
                        </Button>
                    </GridItem>
                </GridContainer>

                { !isEmpty(result) &&
                    <section>
                        <ReactJson src={result} theme="monokai" />
                    </section>
                }

                <input type="submit" style={{ display: "none" }}/>
            </form>

        );
    }
}

export default compose(
    withStyles(customCheckboxRadioSwitch),
    connect(
        ( state, props ) => ({
            result: state.main.item,
            refreshVersion: state.main.refreshVersion,
            tags: state.main.rest.tags || null,
            formValues: getFormValues(props.form)(state),
            initialValues: getFormInitValues(state, DEFAULT_VALUES_FOR_FILE_REGISTRATION ),
            saveOptionValue: formValueSelector(props.form)(state, 'save'),
            submitErrors: getFormSubmitErrors(props.form)(state),
        }), {
            dispatchExtractTags: extractTagsFromFileAction,
            dispatchCrudCreate: crudDocumentFileCreateAction
        }
    ),
    reduxForm({
        //enableReinitialize: true
    })
)(DocumentFileRegistrationDetail);
